import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleRemoveDiscussion(
  state: State,
  discussion: Boundaries["removeDiscussion"]["success"],
): State {
  return state.map((result) => ({
    ...result,
    discussion: {
      ...result.discussion,
      comments: [],
    },
  }));
}

export { handleRemoveDiscussion };
